/**
 * Couriers' photos that wouldn't load, and when: each is tried again after [PHOTO_RETRY_MS], because a bad moment on the
 * network shouldn't leave the initial showing until a reload. Shared by the lists (`Av`) and the map's discs, so one
 * failure isn't tried again by every copy of the same face.
 */
export const PHOTO_RETRY_MS = 30_000;

const failedAt = new Map<string, number>();

export const photoFailed = (url: string) => void failedAt.set(url, Date.now());

/** How long until [url] may be tried again; 0 when it may be tried now. */
export function photoWait(url: string, now = Date.now()): number {
  const at = failedAt.get(url);
  return at == null ? 0 : Math.max(0, at + PHOTO_RETRY_MS - now);
}

/** [url] when it may be tried now, else null. */
export const photoToTry = (url: string | null | undefined): string | null => (url && photoWait(url) === 0 ? url : null);
